import { render, staticRenderFns } from "./TeamBilling.vue?vue&type=template&id=ca347664&"
import script from "./TeamBilling.vue?vue&type=script&lang=js&"
export * from "./TeamBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports